module.exports = __webpack_public_path__ + "img/a1.ecbd9430.png";